class ScrollToHelper {
    /**
     * scroll to a passed element and respect headerHeight for scroll position (important for fixed headers)
     * @param element
     * @param additionalSpacing
     */
    static scrollTo(
        element = null,
        additionalSpacing = ScrollToHelper.isHeaderFixed() ? ScrollToHelper.getHeaderHeight() : 0,
    ) {
        let scrollTop = window.pageYOffset;

        if (window.pageYOffset === undefined) {
            [scrollTop] = (document.documentElement || document.body.parentNode || document.body);
        }

        let top = element !== null ? element.getBoundingClientRect().top + scrollTop : 0;

        if (additionalSpacing !== 0) {
            top -= additionalSpacing;
        }

        window.scrollTo({
            behavior: 'smooth',
            left: 0,
            top,
        });
    }

    /**
     * return the top offset of a passed element
     * @param element
     * @returns {number|number}
     */
    static getElementTopOffset(element = null) {
        let scrollTop = window.pageYOffset;

        if (window.pageYOffset === undefined) {
            [scrollTop] = (document.documentElement || document.body.parentNode || document.body);
        }

        return element !== null ? element.getBoundingClientRect().top + scrollTop : 0;
    }

    /**
     * get the height of the page header (necessary for fixed headers)
     * @returns {number}
     */
    static getHeaderHeight() {
        return document.querySelector('.navigation__wrapper').getBoundingClientRect().height;
    }

    static isHeaderFixed() {
        return window.getComputedStyle(document.querySelector('.page-header')).position === 'fixed';
    }

    /**
     * get all images between the current component-container and the
     * component-container in which the target is located
     * @param currentElement
     * @param targetElement
     * @returns {FlatArray<*[][], 1>[]}
     */
    static getAllImagesBetweenCurrentAndTarget(currentElement, targetElement) {
        if (!currentElement || !targetElement) {
            return null;
        }

        let eventContainer = currentElement.closest('.component-container');
        const targetContainer = targetElement.closest('.component-container');
        const containersToCross = [];

        while (eventContainer) {
            if (eventContainer && eventContainer !== targetContainer) {
                containersToCross.push(eventContainer);
            }
            eventContainer = eventContainer.nextElementSibling;

            if (!eventContainer || eventContainer === targetContainer) {
                break;
            }
        }

        const images = containersToCross.map((container) => {
            return ([...container.querySelectorAll('.lazyload')]);
        });

        return images.flat();
    }
}

export default ScrollToHelper;
